module.exports = __webpack_public_path__ + "img/北京办公室.902caace.jpg";